export const MAX_CUSTOM_CITY_NAME = 60;

export const OTHER_CITY_SLUG = "__other__";

// Top 10 Colombian cities by population. Medellín is the active launch
// city; the list ordering matches civic recognition (Bogotá first).
export const COLOMBIAN_CITIES = [
  { slug: "bogota", name: "Bogotá", live: false },
  { slug: "medellin", name: "Medellín", live: true },
  { slug: "cali", name: "Cali", live: false },
  { slug: "barranquilla", name: "Barranquilla", live: false },
  { slug: "cartagena", name: "Cartagena", live: false },
  { slug: "cucuta", name: "Cúcuta", live: false },
  { slug: "bucaramanga", name: "Bucaramanga", live: false },
  { slug: "pereira", name: "Pereira", live: false },
  { slug: "santa-marta", name: "Santa Marta", live: false },
  { slug: "ibague", name: "Ibagué", live: false },
] as const;

export type CatalogSlug = (typeof COLOMBIAN_CITIES)[number]["slug"];
export type CitySlug = CatalogSlug | typeof OTHER_CITY_SLUG;
export type ColombianCity = (typeof COLOMBIAN_CITIES)[number];

const LIVE_SLUGS = new Set<string>(
  COLOMBIAN_CITIES.filter((c) => c.live).map((c) => c.slug),
);

export function isLiveSlug(slug: string): boolean {
  return LIVE_SLUGS.has(slug);
}

export function computeRank(
  slug: CitySlug,
  counts: Partial<Record<CitySlug, number>>,
): number | null {
  const projected: Record<string, number> = { ...counts };
  projected[slug] = (projected[slug] ?? 0) + 1;
  const ranked = Object.entries(projected)
    .filter(([s]) => !LIVE_SLUGS.has(s))
    .sort((a, b) => b[1] - a[1])
    .findIndex(([s]) => s === slug);
  return ranked === -1 ? null : ranked + 1;
}
